import ajaxRequest from "../../utils/ajaxRequest";
import { API_PARAM } from "./apiParam";

const onRequestToken = async () => {
    let url;
    const formularyElement = document.querySelector("[data-formulary-auth]");
    if (formularyElement) {
        url = formularyElement.getAttribute("data-formulary-auth");
    }
    const promiseObj = new Promise(resolve => {
        ajaxRequest({ url })
            .then(res => {
                const data = JSON.parse(res);
                resolve(data.accessToken);
            })
            .catch(error => {
                resolve(error);
            });
    });
    return promiseObj;
};
export default async function SetToken(btnSubmit) {
    const tokenStorage = sessionStorage.getItem("tokenMMIT");
    if (tokenStorage) {
        API_PARAM.token = tokenStorage;
    } else {
        const token = await onRequestToken();
        if (token) {
            sessionStorage.setItem("tokenMMIT", token);
            API_PARAM.token = token;
        }
    }
    if (btnSubmit) btnSubmit.classList.remove("disabled");
}
